/**
 * variant-delivery.js
 * 
 * Das hier wurde alles von Claude gevibecoded (variant-delivery.js, varaiant-delivery-block.liquid, 
 * und Abschnitte in theme.liquid und variant-picker.liquid)
 *
 * Verwaltet die Lieferzeit-Anzeige pro Produkt-Variante.
 * Wird EINMAL geladen (über assets/), verwaltet aber automatisch
 * ALLE Instanzen von #variant-delivery-info auf der Seite, egal ob
 * variant-picker.liquid einmal oder mehrfach gerendert wurde
 * (z.B. Hauptprodukt + Quick-Add-Karten).
 *
 * WICHTIG: Der Hidden-Input (input[name="id"]) im Cart-Formular wird von
 * Horizon ASYNCHRON aktualisiert - er hat beim change-Event noch den ALTEN
 * Wert. Deshalb lesen wir die Variant-ID bevorzugt direkt vom geklickten
 * Radio-Button (data-variant-id Attribut), das ist sofort korrekt.
 */
(function () {
  if (window.__variantDeliveryInitialized) return;
  window.__variantDeliveryInitialized = true;

  function updateDeliveryTime(wrapper, variantsData, variantId) {
    const deliveryTextElement = wrapper.querySelector('.delivery-time-text');
    if (!deliveryTextElement || !variantId) return;

    const variant = variantsData.find(v => String(v.id) === String(variantId));
    if (!variant) return;

    if (!variant.available && variant.inventory_policy !== 'continue') {
      deliveryTextElement.innerHTML =
        '<span style="color: #6c757d; font-weight: bold;">⛔ Ausverkauft</span>';
    } else if (variant.inventory_policy === 'continue' && variant.inventory_quantity <= 0) {
      deliveryTextElement.innerHTML =
        '<span style="color: #d9534f; font-weight: bold;">📦 Lieferzeit: 10–12 Werktage (Re-Stock)</span>';
    } else {
      deliveryTextElement.innerHTML =
        '<span style="color: #4b8543; font-weight: bold;">🚚 Lieferzeit: 2–4 Werktage (Auf Lager)</span>';
    }
  }

  // Findet zu einem beliebigen DOM-Element (z.B. dem geklickten Radio-Button)
  // den zugehörigen variant-delivery-info-Wrapper im selben Produkt-Scope.
  function findWrapperForElement(el) {
    const scope =
      el.closest('product-info, [id^="MainProduct-"], .product-form, section') || document;
    return scope.querySelector('#variant-delivery-info');
  }

  function getVariantsData(wrapper) {
    const productId = wrapper.dataset.productId;
    const jsonContainer = document.getElementById('product-variants-json-' + productId);
    if (!jsonContainer) return null;
    try {
      return JSON.parse(jsonContainer.textContent);
    } catch (err) {
      console.error('variant-delivery: JSON parse error', err);
      return null;
    }
  }

  function getScopedForm(wrapper) {
    const scope =
      wrapper.closest('product-info, [id^="MainProduct-"], .product-form, section') ||
      document;
    return scope.querySelector('form[action*="/cart/add"]');
  }

  // Fallback-Ermittlung der Variant-ID, falls wir NICHT direkt vom
  // geklickten Element kommen (z.B. initialer Seitenaufruf).
  function getCurrentSelectedVariantId(wrapper) {
    const scope =
      wrapper.closest('product-info, [id^="MainProduct-"], .product-form, section') || document;

    // A) Aktuell markiertes Radio im gleichen Scope (zuverlässig, synchron)
    const activeInput = scope.querySelector(
      'variant-radios input[type="radio"]:checked, .variant-picker input[type="radio"]:checked, variant-selects input[type="radio"]:checked'
    );
    if (activeInput && activeInput.dataset.variantId) {
      return activeInput.dataset.variantId;
    }

    const activeSelect = scope.querySelector('variant-selects select, .variant-picker select');
    if (activeSelect && activeSelect.value) {
      return activeSelect.value;
    }

    // B) URL-Parameter — nur beim initialen Laden des Hauptprodukts sinnvoll
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('variant') && wrapper.dataset.isMainProduct === 'true') {
      return urlParams.get('variant');
    }

    // C) Hidden Input als letzter Fallback (kann bei Klicks veraltet sein,
    // ist aber beim initialen Laden korrekt)
    const form = getScopedForm(wrapper);
    if (form) {
      const hiddenInput = form.querySelector('input[name="id"]');
      if (hiddenInput && hiddenInput.value) {
        return hiddenInput.value;
      }
    }

    return null;
  }

  function refreshWrapper(wrapper) {
    const variantsData = getVariantsData(wrapper);
    if (!variantsData) return;
    const variantId = getCurrentSelectedVariantId(wrapper);
    if (variantId) updateDeliveryTime(wrapper, variantsData, variantId);
  }

  function refreshAll() {
    document.querySelectorAll('#variant-delivery-info').forEach(refreshWrapper);
  }

  // HAUPTWEG: Klick auf ein Radio direkt behandeln, BEVOR sich irgendwas
  // asynchron im Theme verändert. data-variant-id am Radio ist sofort korrekt.
  document.addEventListener('click', function (e) {
    const radio = e.target.closest(
      'variant-radios input[type="radio"], .variant-picker input[type="radio"], variant-selects input[type="radio"]'
    );
    if (!radio) return;
    if (!radio.dataset.variantId) return;

    const wrapper = findWrapperForElement(radio);
    if (!wrapper) return;

    const variantsData = getVariantsData(wrapper);
    if (!variantsData) return;

    updateDeliveryTime(wrapper, variantsData, radio.dataset.variantId);
  });

  // Für Dropdown/Select-Varianten (kein data-variant-id am Radio vorhanden,
  // hier ist select.value bereits beim change-Event korrekt)
  document.addEventListener('change', function (e) {
    const select = e.target.closest('variant-selects select, .variant-picker select');
    if (!select || !select.value) return;

    const wrapper = findWrapperForElement(select);
    if (!wrapper) return;

    const variantsData = getVariantsData(wrapper);
    if (!variantsData) return;

    updateDeliveryTime(wrapper, variantsData, select.value);
  });

  // Nachlauf-Sicherheitsnetz: falls die Variante durch andere Wege geändert
  // wurde (Theme-Apps, programmatische Änderungen, verzögerte Section-Updates),
  // einmal nach dem nächsten Frame final synchronisieren.
  document.addEventListener('change', function (e) {
    if (!e.target.closest('variant-radios, variant-selects, form[action*="/cart/add"]')) return;
    const wrapper = findWrapperForElement(e.target);
    if (!wrapper) return;
    requestAnimationFrame(() => refreshWrapper(wrapper));
  });

  // Initialer Abgleich beim Laden
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }
})();
